const ArchiveNav = (props) => {

    const {
        archiveView,
        setArchiveView,
        setMobileFiltersOpen,
    } = props;


  return (
    <nav className="archive__nav-wrapper">
      <div className={`archive__nav-highlight ${archiveView}`}></div>
      <div className={`archive__nav-item disabled`}>View:</div>
      <button className={`archive__nav-item ${archiveView==="list"?"active":""}`}
      onClick={()=>{
        setArchiveView("list");
        setMobileFiltersOpen(false);
      }}>List</button>
      <button className={`archive__nav-item ${archiveView==="grid"?"active":""}`}
      onClick={()=>{
        setArchiveView("grid");
        setMobileFiltersOpen(false);
      }}>Grid</button>
    </nav>
  );
};

export default ArchiveNav;
